import { render, staticRenderFns } from "./BaseLoadingComponent.vue?vue&type=template&id=5c0b30f6&scoped=true"
import script from "./BaseLoadingComponent.vue?vue&type=script&lang=js"
export * from "./BaseLoadingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0b30f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c0b30f6')) {
      api.createRecord('5c0b30f6', component.options)
    } else {
      api.reload('5c0b30f6', component.options)
    }
    module.hot.accept("./BaseLoadingComponent.vue?vue&type=template&id=5c0b30f6&scoped=true", function () {
      api.rerender('5c0b30f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/BaseLoadingComponent.vue"
export default component.exports